import React from 'react';
import { motion } from 'framer-motion';
export function OrbitRings() {
  return <div className="relative w-full h-full flex items-center justify-center perspective-[1000px]" data-id="element-157">
      <motion.div animate={{
      rotateX: [60, 60],
      rotateZ: [0, 360]
    }} transition={{
      duration: 20,
      repeat: Infinity,
      ease: 'linear'
    }} className="absolute w-[300px] h-[300px] md:w-[500px] md:h-[500px] rounded-full border border-cyan-500/30 shadow-[0_0_30px_rgba(6,182,212,0.2)]" style={{
      transformStyle: 'preserve-3d'
    }} data-id="element-158">
        <div className="absolute top-0 left-1/2 w-3 h-3 bg-cyan-400 rounded-full shadow-[0_0_15px_#06b6d4] -translate-x-1/2 -translate-y-1/2" data-id="element-159" />
      </motion.div>

      <motion.div animate={{
      rotateX: [70, 70],
      rotateY: [20, 20],
      rotateZ: [360, 0]
    }} transition={{
      duration: 25,
      repeat: Infinity,
      ease: 'linear'
    }} className="absolute w-[400px] h-[400px] md:w-[700px] md:h-[700px] rounded-full border border-violet-500/20 shadow-[0_0_40px_rgba(109,40,217,0.15)]" style={{
      transformStyle: 'preserve-3d'
    }} data-id="element-160">
        <div className="absolute bottom-0 left-1/2 w-4 h-4 bg-violet-400 rounded-full shadow-[0_0_20px_#6d28d9] -translate-x-1/2 translate-y-1/2" data-id="element-161" />
      </motion.div>

      <motion.div animate={{
      rotateX: [50, 50],
      rotateY: [-20, -20],
      rotateZ: [0, 360]
    }} transition={{
      duration: 15,
      repeat: Infinity,
      ease: 'linear'
    }} className="absolute w-[200px] h-[200px] md:w-[350px] md:h-[350px] rounded-full border border-blue-500/40 shadow-[0_0_20px_rgba(30,58,138,0.3)]" style={{
      transformStyle: 'preserve-3d'
    }} data-id="element-162">
        <div className="absolute top-1/2 right-0 w-2 h-2 bg-blue-400 rounded-full shadow-[0_0_10px_#1e3a8a] translate-x-1/2 -translate-y-1/2" data-id="element-163" />
      </motion.div>

      <div className="absolute w-24 h-24 md:w-32 md:h-32 bg-gradient-to-br from-cyan-400 via-blue-600 to-violet-900 rounded-full shadow-[0_0_60px_rgba(6,182,212,0.5)] flex items-center justify-center overflow-hidden" data-id="element-164">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-50 mix-blend-overlay" data-id="element-165" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" data-id="element-166" />
      </div>
    </div>;
}